import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useEffect } from 'react';
import { useMonitoreo } from './MonitoreoContext';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

// const useStyles = makeStyles({
//     root: {
//         width: '100%',
//         display: 'flex',
//         justifyContent: 'end',
//     },
// });

export default function SimpleTabs() {
    const {
        intervalo,
        setIntervalo,
        setIsLoadingTable,
        setDataP,
        setMinX,
        setMaxX,
        setDataEfi,
        setDataUti,
        setXEfiUti,
        value,
        setValue,
        selectedHierLinea,
    } = useMonitoreo();

    const noLine = !selectedHierLinea;

    // Cuando se deselecciona la línea y estamos en "Corrida", cambiar a 4 Horas
    useEffect(() => {
        if (noLine && value === 0) {
            setValue(1);
            setIntervalo(4);
            setDataP([]);
            setMinX(0);
            setMaxX(0);
            setDataEfi([]);
            setDataUti([]);
            setXEfiUti([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [noLine]);

    // value=0→Corrida, 1→4H, 2→8H, 3→12H (con Corrida)
    // sin Corrida: tab index 0→4H(value=1), 1→8H(value=2), 2→12H(value=3)
    const displayValue = noLine ? Math.max(0, value - 1) : value;

    const handleChange = (event, tabIndex) => {
        const actualValue = noLine ? tabIndex + 1 : tabIndex;
        setIsLoadingTable(true);
        setValue(actualValue);
        if (actualValue === 0) {
            setIntervalo(0);
        } else if (actualValue === 1) {
            setIntervalo(4);
        } else if (actualValue === 2) {
            setIntervalo(8);
        } else {
            setIntervalo(12);
        }
        setDataP([]);
        setMinX(0);
        setMaxX(0);
        setDataEfi([]);
        setDataUti([]);
        setXEfiUti([]);
    };

    useEffect(() => {
        if (intervalo === 0) {
            setValue(0);
        } else if (intervalo === 4) {
            setValue(1);
        } else if (intervalo === 8) {
            setValue(2);
        } else {
            setValue(3);
        }
    }, [intervalo, setValue]);

    return (
        <div className="static" style={{ width: '100%' }}>
            <AppBar position="static">
                <Tabs value={displayValue} onChange={handleChange}>
                    {!noLine && <Tab label="Corrida" />}
                    <Tab label="4 Horas" />
                    <Tab label="8 Horas" />
                    <Tab label="12 Horas" />
                </Tabs>
            </AppBar>
        </div>
    );
}
